import pageheader from "../pageheader";
import InfoDialog from "@/components/InfoDialog";
import utils from "../../utils/util";
import { mapGetters } from "vuex";
import telematicsService from "../../api/telematics.service";



export default {
  name: 'customers',
  components: { InfoDialog, pageheader },

  data () {
    return {
input:{},
isCustomersLoading:false,
customers: [

],
toggle_exclusive: undefined,
headers: [
  { text: "Logo", value: "actionIcon", sortable: false, align: "left" },
  { text: "Customer Name", value: "companyName" },
  { text: "Customer Key", value: "customerKey" },
  { text: "Address Line1", value: "addressesLine1" },
  { text: "Address", value: "addresses" },
  { text: "Contact Phone", value: "phones" },
  { text: "Actions", value: "action" },
],
listCount: 0,
historyList: [],
pageNumber: 1,
pageSize: 52,
totalRecords:0,
totalRecordsCount:0,
countLables:[
  {
    name:"10",
    count:10
  },
  {
    name:"25",
    count:25
  },
  {
    name:"50",
    count:50
  },
  {
    name:"52",
    count:52
  },
  {
    name:"ALL",
    count:-1
  },
],
isFilter: false,
customerSearch: ""
    }
  },
  computed: {
    ...mapGetters(["roles","activeToggleBtnVal"]),
    startPageCount() {
      return this.pageNumber == -1 ? 1 : ((this.pageNumber-1) * this.pageSize) + 1;
    },
    endPageCount() {
      return this.pageNumber == -1 || this.pageNumber == 1 ? this.customers.length : ((this.pageNumber-1) * this.pageSize) + this.customers.length;
    }
  },
  created(){
    this.toggle_exclusive = this.activeToggleBtnVal;
 },
  mounted () {
    this.input = utils.getInputContent("customers", this.roles);
    if(this.$route.query && this.$route.query.isFilter){
      this.customerSearch = this.$route.query.search;
      this.isFilter = this.$route.query.isFilter;
    }
this.getCustomers();
  },
  beforeDestroy() {
    //clear the stored toggleBtn Val on page destroy
    this.$store.dispatch("setActiveToggleVal", 0);
  },
  methods: {
    onToggleBtnChange(){
      this.$store.dispatch("setActiveToggleVal", this.toggle_exclusive);
      this.getCustomers();
    },
    async getCustomers(){
      if(this.customerSearch){
        this.isFilter = true;
        this.$router.replace(`/customers?search=${this.customerSearch}&isFilter=${this.isFilter}`).catch(()=>{});
      }else{
        this.isFilter = false;
        this.customerSearch = "";
        this.$router.replace(`/customers`).catch(()=>{});
      }
      this.isCustomersLoading = true;
      try{
        let response = await telematicsService.getCustomersList(this.pageNumber,this.pageSize,this.customerSearch);
        if(response){
          this.isCustomersLoading = false;
          this.customers = response.data;
          this.totalRecordsCount = response.totalRecords;
          let totalRecords = Math.ceil( this.totalRecordsCount/ this.pageSize);
          if(this.pageSize == -1){
            this.totalRecords = 1;
          }else{
          this.totalRecords = parseInt(totalRecords);
          }
        }else{
          this.isCustomersLoading = false;
          this.customers = [];
        }
      }catch(err){
        console.log(err);
        this.isCustomersLoading = false;
        this.customers = [];
      }
    },
    clearFilters(){
      this.customerSearch = "";
      this.$router.replace(`/customers`);
      this.getCustomers();
    },
    viewCustomerDetails(itemId) {
      const search = this.$route.query && this.$route.query.isFilter ? this.customerSearch : '';
      this.$router.push({ name: "View Customer Details", params: { id: itemId }, query: { search, isFilter: this.isFilter } });
    },
    pageChange(){
      this.getCustomers();
    },
    getFirstPageData(){
      this.pageNumber = 1;
      this.pageSize = 52;
      this.getCustomers();
    },
    getLastPageData(){
      this.pageNumber = this.totalRecords;
      this.pageSize = 52;
      this.getCustomers();
    }
  }
}


